/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_AriaInputs */

const en_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

const fr_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations`)
};

const de_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen`)
};

const it_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permessi`)
};

const ru_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешения`)
};

const es_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos`)
};

const zh_cn2_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限`)
};

const ja_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`権限`)
};

const hi_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमतियां`)
};

const pt_pt2_explorer_info_permissions_aria = /** @type {(inputs: Explorer_Info_Permissions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões`)
};

/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Explorer_Info_Permissions_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_aria = /** @type {((inputs?: Explorer_Info_Permissions_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_permissions_aria(inputs)
	if (locale === "de") return de_explorer_info_permissions_aria(inputs)
	if (locale === "it") return it_explorer_info_permissions_aria(inputs)
	if (locale === "ru") return ru_explorer_info_permissions_aria(inputs)
	if (locale === "es") return es_explorer_info_permissions_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_permissions_aria(inputs)
	if (locale === "ja") return ja_explorer_info_permissions_aria(inputs)
	if (locale === "hi") return hi_explorer_info_permissions_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_permissions_aria(inputs)
	return en_explorer_info_permissions_aria(inputs)
});